/* eslint-disable */
import React, { useState } from "react";
import {
  Flex,
  Box,
  Input,
  Button,
  IconButton,
  useBreakpointValue,
  Text,
  Link,
  useDisclosure,
  Spinner,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  DrawerBody,
  Heading,
  Icon,
  VStack,
} from "@chakra-ui/react";
import { FaBars, FaBrain } from "react-icons/fa";
import { useNavigate, useLocation } from "react-router-dom";
import { NavBarDrawer } from "../components/NavBarDrawer";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Avatar,
  Switch,
  FormLabel,
  useColorMode
} from "@chakra-ui/react";

const Navbar = () => {
  const { colorMode, toggleColorMode } = useColorMode();
  const isMobile = useBreakpointValue({ base: true, lg: false });
  const { isOpen, onOpen, onClose } = useDisclosure();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userStore = useSelector((store) => store.UserReducer);
  const location = useLocation();

  const { isOpen: isAiOpen, onOpen: onAiOpen, onClose: onAiClose } = useDisclosure();
  const [messages, setMessages] = useState([
    { sender: "ai", text: "Hello! I am your SkillUp Corporate Mentor. 🌟\n\nI can recommend the perfect training courses for your role, tell you about current compliance assignments, or explain any professional concept or technical term. What would you like to learn today?" }
  ]);
  const [aiInput, setAiInput] = useState("");
  const [isAiLoading, setIsAiLoading] = useState(false);

  const handleSendAi = async () => {
    if (!aiInput.trim()) return;
    const textToSend = aiInput;
    setMessages(prev => [...prev, { sender: "user", text: textToSend }]);
    setAiInput("");
    setIsAiLoading(true);

    try {
      const token = userStore?.token || JSON.parse(localStorage.getItem('user'))?.token;
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/courses/dashboard/ask-ai`, {
        question: textToSend
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setMessages(prev => [...prev, { sender: "ai", text: response.data.answer }]);
    } catch (err) {
      console.error(err);
      const errMsg = err.response?.data?.message || err.response?.data || "Sorry, I ran into an issue answering your question. Please try again.";
      setMessages(prev => [...prev, { sender: "ai", text: errMsg }]);
    } finally {
      setIsAiLoading(false);
    }
  };

  const handleLogout = () => {
    dispatch({ type: "USER_LOGOUT" });
    navigate("/");
  };

  const getDashboardLink = () => {
    if (userStore.role === "admin" || userStore.role === "super_admin") return "/admin/dashboard";
    if (userStore.role === "teacher" || userStore.role === "instructor") return "/teacher-dashboard";
    return "/home";
  };

  return (
    <Box>
      <Flex
        as="nav"
        align="center"
        justify="space-between"
        px={{ base: 6, md: 12 }}
        py={6}
        bg="transparent"
        position="absolute"
        width="100%"
        zIndex={1000}
      >
        <Flex align="center" onClick={() => navigate("/")} _hover={{ cursor: "pointer" }}>
          <img src="/Workforce.svg" alt="Workforce Logo" style={{ height: "100px", objectFit: "contain", filter: "brightness(0)" }} />
        </Flex>

        {!isMobile && (
          <Flex flex={1} justify="center" gap={8}>
          </Flex>
        )}

        {isMobile ? (
          <IconButton aria-label="Menu" icon={<FaBars />} variant="ghost" onClick={onOpen} />
        ) : (
          <Flex align="center">
            {userStore.isAuth ? (
              <Menu>
                <MenuButton>
                  <Flex align="center" gap={2} cursor="pointer">
                    <Avatar size="sm" name={userStore.name} src={userStore.avatar} />
                    <Text fontSize="sm" fontWeight="600">{userStore.name?.split(' ')[0]}</Text>
                  </Flex>
                </MenuButton>
                <MenuList color="black">
                  <MenuItem onClick={() => navigate(getDashboardLink())}>Dashboard</MenuItem>
                  <MenuItem onClick={() => navigate("/profile")}>Profile</MenuItem>
                  <MenuItem onClick={handleLogout} color="red.500">Logout</MenuItem>
                </MenuList>
              </Menu>
            ) : process.env.REACT_APP_DEV_ALLOW_PASSWORD_LOGIN === 'true' ? (
              <Button bgGradient="linear(to-r, purple.600, blue.600)" color="white" _hover={{ bgGradient: "linear(to-r, purple.700, blue.700)" }} onClick={() => navigate("/login")}>
                Sign In
              </Button>
            ) : null}
          </Flex>
        )}
      </Flex>
      <NavBarDrawer
        isOpen={isOpen}
        onOpen={onOpen}
        onClose={onClose}
      />

      {/* Floating AI Mentor Chatbot */}
      {(userStore?.token || JSON.parse(localStorage.getItem('user'))?.token) && !location.pathname.startsWith('/course/') && (
        <>
          <Button
            position="fixed"
            bottom={8}
            right={8}
            bgGradient="linear(to-r, purple.500, blue.500)"
            _hover={{ bgGradient: "linear(to-r, purple.600, blue.600)", transform: "translateY(-2px)" }}
            transition="all 0.2s"
            color="white"
            borderRadius="full"
            h="60px"
            px={6}
            boxShadow="2xl"
            zIndex={1000}
            leftIcon={<Icon as={FaBrain} />}
            onClick={onAiOpen}
          >
            Ask SkillUp Mentor
          </Button>

          <Drawer isOpen={isAiOpen} placement="right" onClose={onAiClose} size="md">
            <DrawerOverlay backdropFilter="blur(4px)" />
            <DrawerContent borderLeftRadius="2xl" overflow="hidden">
              <DrawerCloseButton color="white" zIndex={2000} />

              <Box bgGradient="linear(to-r, purple.600, blue.600)" p={6} color="white">
                <Flex align="center" gap={3}>
                  <Icon as={FaBrain} w={6} h={6} />
                  <Box>
                    <Heading size="md" fontWeight="800">SkillUp Career Advisor</Heading>
                    <Text fontSize="xs" opacity={0.9}>Corporate Pathway & Recommendation Mentor</Text>
                  </Box>
                </Flex>
              </Box>

              <DrawerBody bg="gray.50" p={4} display="flex" flexDir="column" gap={4} overflowY="auto">
                <Flex direction="column" gap={3} flex={1}>
                  {messages.map((m, idx) => (
                    <Flex
                      key={idx}
                      justify={m.sender === 'user' ? 'flex-end' : 'flex-start'}
                    >
                      <Box
                        maxW="80%"
                        p={3.5}
                        borderRadius="2xl"
                        bgGradient={m.sender === 'user' ? 'linear(to-r, purple.500, blue.500)' : undefined}
                        bg={m.sender === 'user' ? undefined : 'white'}
                        color={m.sender === 'user' ? 'white' : 'gray.800'}
                        boxShadow="sm"
                        fontSize="sm"
                        border={m.sender === 'ai' ? '1px solid' : 'none'}
                        borderColor="gray.150"
                      >
                        <Text whiteSpace="pre-line">{m.text}</Text>
                      </Box>
                    </Flex>
                  ))}
                  {isAiLoading && (
                    <Flex justify="flex-start">
                      <Box maxW="80%" p={3.5} borderRadius="2xl" bg="white" shadow="sm" border="1px solid" borderColor="gray.150">
                        <Spinner size="xs" color="purple.500" />
                      </Box>
                    </Flex>
                  )}
                </Flex>
              </DrawerBody>

              <Box p={4} bg="white" borderTop="1px solid" borderColor="gray.100">
                <Flex gap={2}>
                  <Input
                    placeholder="Ask for recommendations or career guidance..."
                    value={aiInput}
                    onChange={(e) => setAiInput(e.target.value)}
                    onKeyDown={(e) => e.key === 'Enter' && handleSendAi()}
                    borderRadius="xl"
                  />
                  <Button bgGradient="linear(to-r, purple.500, blue.500)" _hover={{ bgGradient: "linear(to-r, purple.600, blue.600)" }} color="white" borderRadius="xl" onClick={handleSendAi}>Send</Button>
                </Flex>
              </Box>
            </DrawerContent>
          </Drawer>
        </>
      )}
    </Box>
  );
};

export default Navbar;
